import React from 'react';
import { CellProps, isIntegerControl, RankedTester, rankWith, WithClassname } from '@jsonforms/core';
import { ChakraInputInteger } from '../chakra-controls';
import { withNamedJsonFormsCellProps } from '@/forms-renderers/chakra-ui/utils/withNamedJsonFormsHOC';

export const ChakraIntegerCell = (props: CellProps & WithClassname) => <ChakraInputInteger {...props} />;

export const chakraIntegerCellTester: RankedTester = rankWith(2, isIntegerControl);
export default withNamedJsonFormsCellProps(ChakraIntegerCell);
